import Collapse from "@material-ui/core/Collapse";
import { useState } from "react";
import { AdionarCap } from "../ModalAddCap";

export function CAP() {
    const [showCap, setShowCap] = useState(false);

    return (
        <>
            <div className="d-flex flex-wrap justify-content-center align-items-center col-12">
                <div className="text-center">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Adicionar CAP</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="AgruparBoleto"
                                type="checkbox"
                                checked={showCap}
                                onChange={(e) => setShowCap(e.target.checked)}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
            </div>
            <Collapse in={showCap}>
                <AdionarCap active={showCap} />
            </Collapse>
        </>
    );
}
